import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import MultiSelect from 'react-multi-select-component'
import _ from 'common-tools/LodashHelper'
import styles from './MultiSelectComboBox.less'

class MultiSelectComboBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    options: pt.arrayOf(pt.object).isRequired,
    textProp: pt.string.isRequired,
    valueProp: pt.string.isRequired,
    allowSearch: pt.bool.isRequired
  })

  static defaultProps = {
    textProp: 'Text',
    valueProp: 'Value',
    options: [],
    allowSearch: false
  }

  render () {
    const { options, textProp, valueProp, allowSearch, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading, readonly }) => {
          return <MultiSelect
            className={styles.root}
            disabled={readonly}
            options={_.map(options, (o) => {
              return {
                label: o[textProp],
                value: o[valueProp]
              }
            })}
            value={value || []}
            onChange={onChange}
          />
        }}
      </FieldLayoutBox>
    )
  }
};

export const MultiSelectComboBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={MultiSelectComboBoxClass} /> } // eslint-disable-line
export default MultiSelectComboBox
